// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const valueMustBeWithinMaxLength = (v = '', m) => (
  !(v.length <= +m) && `${m} character${m > 1 ? 's' : ''} max`
)

export default valueMustBeWithinMaxLength
